export default [
  {
    path: '', // 👈 Esto hace que sea la ruta por defecto al entrar a la sucursal
    name: 'empresa.sucursal.dashboard',
    component: () => import('@/views/empresa/sucursales/dashboard/EmpresaSucursalDashboard.vue'),
  },
]
